import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { BonificacionDto } from '@models/bonificaciones/bonificacionDto.model';
import { CreateBonificacionRequest } from '@models/bonificaciones/createBonificacionRequest.model';
import { CreateBonificacionResponse } from '@models/bonificaciones/createBonificacionResponse.model';
import { UpdateBonificacionRequest } from '@models/bonificaciones/updateBonificacionRequest.model';
import { isFalsy } from 'utility-types';

@Injectable({
  providedIn: 'root'
})
export class BonificacionesService {

  private id!: number;

  set setId(id:number) {
    this.id = id;
  }

  get getId() {
    return this.id;
  }

  constructor(
    private http: HttpClient
  ) { }

  create(createBonificacionRequest:CreateBonificacionRequest):Observable<CreateResponseBase>
  {
    return  this.http.post<CreateResponseBase>("/api/Bonificacion/Create",createBonificacionRequest);
  }

  update(updateBonificacionRequest:UpdateBonificacionRequest):Observable<any>
  {
    return  this.http.put<any>("/api/Bonificacion/Update",updateBonificacionRequest);
  }

  getAll():Observable<BonificacionDto[]>
  {
    return  this.http.get<BonificacionDto[]>("/api/Bonificacion/GetAll");
  }

  getById(id:number):Observable<BonificacionDto>
  {
    return  this.http.get<BonificacionDto>("/api/Bonificacion/GetById?id="+id);
  }

  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/Bonificacion/Delete?id=" + id);
    else
      return of(null)
  }
}
